export * from './promotionObject'
